<app-dialog-heading [heading]="heading"></app-dialog-heading>
<mat-dialog-content>
  <form [formGroup]="formGroup">

    <!--------------------------->
    <!--Row-1-->
    <!--------------------------->

    <mat-grid-list cols="2" rowHeight="90px">
      <mat-grid-tile>
        <mat-form-field class="w-90">
          <mat-label>First Name</mat-label>
          <input matInput type="text" [formControlName]="controls.FirstName" required>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip(controls.FirstName)">
          help_outline
        </mat-icon>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-form-field class="w-90">
          <mat-label>Email</mat-label>
          <input matInput type="email" [formControlName]="controls.EmailAddress" required>
          <mat-error *ngIf="emailFormAbstractControl.invalid">
            <span *ngIf="emailFormAbstractControl.errors?.invalidEmail">Invalid email address.</span>
          </mat-error>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip(controls.EmailAddress)">
          help_outline
        </mat-icon>
      </mat-grid-tile>
    </mat-grid-list>

    <!--------------------------->
    <!--Row-2-->
    <!--------------------------->

    <mat-grid-list cols="2" rowHeight="90px">
      <mat-grid-tile>
        <mat-form-field class="w-90">
          <mat-label>Last Name</mat-label>
          <input matInput type="text" [formControlName]="controls.LastName">
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip(controls.LastName)">
          help_outline
        </mat-icon>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-form-field class="w-90">
          <mat-label>Username</mat-label>
          <input matInput type="text" [formControlName]="controls.KeycloakId" required>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip(controls.KeycloakId)">
          help_outline
        </mat-icon>
      </mat-grid-tile>
    </mat-grid-list>

    <!--------------------------->
    <!--Row-3-->
    <!--------------------------->

    <mat-grid-list cols="2" rowHeight="90px">
      <mat-grid-tile>
        <mat-form-field class="w-90">
          <mat-label>Roles</mat-label>
          <mat-select [formControlName]="controls.UserRoles"
                      (selectionChange)="onRolesSelectionChange($event.source.value)"
                      required
                      multiple>
            <mat-option *ngFor="let userRole of allUserRoles" [value]="userRole.role_Name">
              {{userRole.role_Name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="userRolesFormAbstractControl.invalid">
            <span *ngIf="userRolesFormAbstractControl.errors?.atleastOneValue">
              At least one role should be assigned to the user
            </span>
          </mat-error>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip(controls.UserRoles)">
          help_outline
        </mat-icon>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-slide-toggle [formControlName]="controls.isActive">
          Enabled?
        </mat-slide-toggle>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip(controls.isActive)">
          help_outline
        </mat-icon>
      </mat-grid-tile>
    </mat-grid-list>

    <!--------------------------->
    <!--Row-3-->
    <!--------------------------->

    <mat-grid-list cols="2" rowHeight="90px" *ngIf="showLinkedEntity()">
      <mat-grid-tile>
        <mat-form-field class="w-90">
          <mat-label>Linked Entity</mat-label>
          <input matInput
                  [formControlName]="controls.LinkedEntityCode"
                  [matAutocomplete]="linkedEntity"
                  [required]="showLinkedEntity()"
                  (input)="onInputChangedLinkedEntity($event)"
                  (blur)="onLinkedEntityBlur()">
          <mat-autocomplete
            #linkedEntity="matAutocomplete"
            [panelWidth]="'30vw'">
            <mat-option *ngFor="let entity of linkedEntities"
                        [value]="entity.code">
              {{ getLinkedEntityDisplayString(entity) }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip(controls.LinkedEntityCode)">help_outline</mat-icon>
      </mat-grid-tile>

      <mat-grid-tile></mat-grid-tile>
    </mat-grid-list>

  </form>
  <p style="color: red">{{errorMessage}}</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-raised-button [mat-dialog-close]="false" color="warn">
    Cancel
  </button>
  <button mat-raised-button color="primary" [disabled]="!formGroup.valid"
          (click)="saveUser($event)">
      {{selectedUser?.requiresApproval === 1 ? 'Approve' : 'Save'}}
    <app-busy-spinner-icon [isBusyCounter]="isBusyCounter"></app-busy-spinner-icon>
    <mat-icon *ngIf="!formGroup.valid"
              class="info-icon" [matTooltip]="'All fields are required'">
      help_outline
    </mat-icon>
  </button>
</mat-dialog-actions>
